import { createGlobalStyle } from 'styled-components'

/* override sked preview icon size */
const GlobalStyle = createGlobalStyle`
  // sked preview css, leave these nightmare here for now

  [class^="icon-"], [class*=" icon-"]
  {    
    font-size: 22px !important;
  }

  [class^="Media__InfoIconWrap"] {
    svg {
      top: 0 !important;
    }
  }

  [class^="Linkedinstyles__Typography"] {
    ~ div {
      > div {
        > div:not([class^="Media__DocumentInfo"]) {
          gap: 20px;
        }
      }
    }

    [class*=" icon-linkedin"] {
      font-size: 14px !important;

      ~ div {
        font-size: 15px !important;
        font-weight: 500;
      }
    }
  }

  [class^="Story__LinkWrapper"] {
    height: 44px !important;
    > a > div {
      height: 28px !important;
    }
  }
`

export default GlobalStyle
